var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-path-vue"},[_c('span',{staticClass:"pushHome",on:{"click":_vm.pushHme}},[_vm._v("404未找到页面，点击返回")])])}
var staticRenderFns = []

export { render, staticRenderFns }